import AnimatedLoader from "../component/loader/Loader";
import ModernLoader, { ModernModalLoader, PulsingDotsLoader } from "../component/loader/ModernLoader";

export const LoaderComponent = ({ loaderType = "", height='80vh', showText= true }) => {
	return (
		<>
			<div
				className="flex items-center justify-center w-full"
				style={{ height: height }}>
				{loaderType === "animated" ? (
					<AnimatedLoader />
				) : loaderType === "modal" ? (
					<ModernModalLoader isVisible={true} text="Loading..." />
				) : loaderType === "modern" ? (
					<ModernLoader size="large" text="Loading..." type="rings" />
				) : loaderType === "dots" ? (
					<PulsingDotsLoader size="large" />
				) : loaderType === "svg" ? (
					<ModernLoader size="default" text="Loading..." showText={showText} type="svg" />
				) : (
					<ModernLoader size="default" text="Loading..." showText={showText} type="svg" />
				)}
			</div>
		</>
	);
};
